import { Stethoscope, Accessibility, Hospital, Users2, CheckCircle2, Car } from "lucide-react";

const SERVICES = [
  { Icon: Stethoscope, title: "Medical Appointments", desc: "Reliable transportation to and from medical appointments.", details: ["Timely pickup and drop-off", "Assistance from vehicle to door", "Coordination with appointment times"] },
  { Icon: Accessibility, title: "Wheelchair Transportation", desc: "Safe and comfortable transportation for passengers requiring wheelchair accessibility.", details: ["ADA-friendly vehicles", "Secure lift and tie-down", "Trained, respectful drivers"] },
  { Icon: Hospital, title: "Hospital Transportation", desc: "Reliable transportation for hospital visits, appointments, and discharge.", details: ["Discharge coordination", "Comfortable rides home", "Multi-appointment scheduling"] },
  { Icon: Users2, title: "Senior Transportation", desc: "Comfortable and respectful transportation for seniors and individuals requiring additional assistance.", details: ["Patient, respectful support", "Assistance with mobility aids", "Family-friendly communication"] },
  { Icon: Car, title: "Private Transportation", desc: "Discreet, on-demand private rides for non-medical trips, family visits, and errands.", details: ["Point-to-point private rides", "Professional, courteous drivers", "Flexible scheduling"] },
];

export default function Services() {
  return (
    <div className="animate-fade-up">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.2em] text-[#1D4ED8] font-semibold mb-3">Our Services</div>
          <h1 className="text-4xl sm:text-5xl font-bold text-[#0A192F]">Transportation options for every need</h1>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">Comfortable, reliable rides to help you get where you need to go — safely and on time.</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {SERVICES.map(({ Icon, title, desc, details }) => (
            <div key={title} className="rounded-2xl bg-white border border-slate-200 p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-blue-50 text-[#1D4ED8] flex items-center justify-center shrink-0">
                  <Icon className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-[#0A192F]">{title}</h3>
                  <p className="mt-2 text-slate-600 leading-relaxed">{desc}</p>
                  <ul className="mt-4 space-y-2">
                    {details.map((d) => (
                      <li key={d} className="flex items-start gap-2 text-sm text-slate-700">
                        <CheckCircle2 className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0" /> {d}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
